import {
  Alert,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from '@mui/material';

import EPPhoneCell from './EPPhoneCell';
import type { EPP1ViewContentProps } from './EscalationProfile.types';

const EPP1ViewContent = ({
  callingEnabled,
  callOrderUsers,
  missingPhoneUsers
}: EPP1ViewContentProps) => {
  if (!callingEnabled) {
    return (
      <Stack sx={{ pt: 0.5 }} spacing={1.5}>
        <Typography color="warning">
          Phone call notifications are OFF
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack spacing={1}>
      <Typography sx={{ fontWeight: 'bold', pt: 1 }}>
        Notified via phone call in the following order
      </Typography>
      {callOrderUsers.length === 0 ? (
        <Typography variant="body2" color="warning">
          No users configured for call order
        </Typography>
      ) : (
        <>
          {missingPhoneUsers.length > 0 && (
            <Alert severity="warning">
              The following users are missing a phone number:{' '}
              <Typography sx={{ fontWeight: 'bold' }} component="span">
                {missingPhoneUsers.map((u) => u.name).join(', ')}
              </Typography>
            </Alert>
          )}
          <Table size="small">
            <TableBody>
              {callOrderUsers.map((user, idx) => (
                <TableRow key={user.id}>
                  <TableCell sx={{ width: '2rem', py: 0.5 }}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      {idx + 1}
                    </Typography>
                  </TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>
                    <EPPhoneCell user={user} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </Stack>
  );
};

export default EPP1ViewContent;
